import React from "react";
import { Grid, IconButton, TextField, Typography } from "@material-ui/core";
import AuthorizationWrapper from "../AuthorizationWrapper";
import { Add, Remove } from "@material-ui/icons";

function ArraySetting(props) {
  const [values, setValues] = React.useState(props.setting.value ? props.setting.value : []);
  return (
    <AuthorizationWrapper
      permission={props.authenticationName}
      child={(write) => {
        return (
          <>
            <Grid container alignItems={"flex-start"} spacing={1}>
              <Grid item xs={4}>
                <Typography>{props.label}</Typography>
              </Grid>
              <Grid item xs={8}>
                {values.map((value, index) => (
                  <div style={{ display: "flex" }}>
                    <TextField
                      fullWidth
                      disabled={!write}
                      value={value}
                      onChange={(e) => {
                        values[index] = e.target.value;
                        setValues([...values]);
                      }}
                      onBlur={() => {
                        props.onChange(values);
                      }}
                    />
                    <IconButton
                      onClick={() => {
                        let newValues = [...values];
                        newValues.splice(index, 1);
                        setValues(newValues);
                        props.onChange(newValues);
                      }}
                    >
                      <Remove />
                    </IconButton>
                  </div>
                ))}
              </Grid>
              <Grid item xs={4} />
              <Grid item xs={8} container justify={"flex-end"}>
                <IconButton
                  onClick={() => {
                    setValues([...values, ""]);
                  }}
                >
                  <Add />
                </IconButton>
              </Grid>
            </Grid>
            {props.children}
          </>
        );
      }}
    />
  );
}

export default ArraySetting;
